<script lang="ts" setup>
import ClassroomAssignmentSummaryModal from "./SummaryModal.vue";

const props = defineProps({
  classroomId: {
    type: String,
    required: true,
  },
  assignmentId: {
    type: String,
    required: true,
  },
  alwaysShow: {
    type: Boolean,
    default: false,
  },
  enableOpenButton: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const assignmentDataStore = useAssignmentDataStore(
  props.classroomId,
  props.assignmentId
);

const { assignment, ungradedFinalDrafts, numGradedFinalDraftDocuments } =
  storeToRefs(assignmentDataStore);

const uid = useCurrentUID();

const classroomDataStore = useClassroomDataStore(uid!, props.classroomId);

const { students } = storeToRefs(classroomDataStore);

const numSubmittedDocuments = computed(() => {
  return ungradedFinalDrafts.value.length + numGradedFinalDraftDocuments.value;
});

const numStudents = computed(() => {
  return students.value.length;
});

const assignmentProgressSheetController = useNewSheetController();

const showSummary = () => {
  assignmentProgressSheetController.value.open();
};
</script>

<template>
  <div>
    <div class="flex flex-row items-center">
      <BaseMultiProgressBar
        v-if="
          alwaysShow ||
          numSubmittedDocuments > 0 ||
          numGradedFinalDraftDocuments > 0
        "
        :key="
          numSubmittedDocuments + numGradedFinalDraftDocuments + students.length
        "
        :max-value="numStudents"
        :primary-value="numSubmittedDocuments"
        :primary-tooltip="`${numSubmittedDocuments} / ${students.length} submitted`"
        :secondary-value="numGradedFinalDraftDocuments"
        :secondary-tooltip="`${numGradedFinalDraftDocuments} / ${students.length} graded`"
        class="w-full mt-2 mb-2 cursor-pointer grow"
        :height="10"
        @click="enableOpenButton == true ? undefined : showSummary"
      />
      <BaseIconButton
        v-if="enableOpenButton"
        @click="showSummary"
        class="pointer-events-auto ml-1 mb-[1px]"
      >
        <BaseIconOpenLink />
      </BaseIconButton>
    </div>
    <ClassroomAssignmentSummaryModal
      :classroom-id="classroomId"
      :assignment-id="assignmentId"
      :controller="assignmentProgressSheetController"
      class="h-full"
    />
  </div>
</template>

<style scoped></style>
